import { render, staticRenderFns } from "./Notices.vue?vue&type=template&id=28f43eb2&scoped=true"
import script from "./Notices.vue?vue&type=script&lang=js"
export * from "./Notices.vue?vue&type=script&lang=js"
import style0 from "./Notices.vue?vue&type=style&index=0&id=28f43eb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f43eb2",
  null
  
)

export default component.exports